import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fr from 'vuetify/lib/locale/fr';
import { theme } from '@/theme';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr },
    current: 'fr',
  },
  icons: {
    iconfont: 'md'
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: theme.colors.light,
      dark: theme.colors.dark,
    },
  },
})